// 会员管理
import http from "@/jslibs/axios/http";

// 会员列表
export const list = (data) => http.get("/v1/cms/user", data);

// 会员新增
export const add = (data) => http.post("/v1/cms/user", data);

// 会员详情
export const detail = ({ uuid }) => http.get(`/v1/cms/user/${uuid}`);

// 会员编辑
export const edit = ({ uuid, ...data }) => http.put(`/v1/cms/user/${uuid}`, data);

// 会员删除
export const del = ({ uuid }) => http.delete(`/v1/cms/user/${uuid}`);

// 浏览记录
export const history = ({ uuid, ...data }) => http.get(`/v1/cms/user/history/${uuid}`, data);

// 设置代理
export const setdl = (data) => http.post(`/v1/cms/user/set_dl`, data);
